var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865,
    zoomAndPan: "magnify",
    viewBox: "0 0 648.75 225",
    height: 300,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.171875 6.089844 L 632.390625 6.089844 L 632.390625 219.089844 L 18.171875 219.089844 Z M 18.171875 6.089844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.421875 26.476562 L 404.921875 26.476562 L 404.921875 198.976562 L 40.421875 198.976562 Z M 40.421875 26.476562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.749971, 0, 0, 0.750372, 18.170975, 6.090479)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00119949 -0.000846719 L 818.990857 -0.000846719 L 818.990857 283.858538 L 0.00119949 283.858538 L 0.00119949 -0.000846719 ",
    stroke: "#000000",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.429688 26.476562 L 404.917969 26.476562 L 404.917969 198.976562 L 40.429688 198.976562 L 40.429688 26.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.252988, 141.219383)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 34.695312 1.074219 C 35.851562 1.074219 36.925781 0.992188 38 0.910156 L 39.15625 3.71875 C 42.214844 11.070312 47.5 14.292969 56.257812 14.292969 L 61.707031 14.292969 L 61.707031 7.351562 L 56.835938 7.351562 C 50.308594 7.351562 47.996094 6.03125 45.929688 1.15625 L 45.269531 -0.578125 C 57 -4.460938 64.683594 -15.117188 64.683594 -28.914062 C 64.683594 -46.507812 52.292969 -58.898438 34.695312 -58.898438 C 17.101562 -58.898438 4.792969 -46.507812 4.792969 -28.914062 C 4.792969 -11.316406 17.101562 1.074219 34.695312 1.074219 Z M 12.226562 -28.914062 C 12.226562 -42.378906 21.394531 -51.628906 34.695312 -51.628906 C 47.996094 -51.628906 57.164062 -42.378906 57.164062 -28.914062 C 57.164062 -15.449219 47.996094 -6.195312 34.695312 -6.195312 C 21.394531 -6.195312 12.226562 -15.449219 12.226562 -28.914062 Z M 12.226562 -28.914062 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.900061, 141.219383)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 30.070312 0.992188 C 44.03125 0.992188 52.457031 -8.179688 52.457031 -23.542969 L 52.457031 -57.828125 L 45.1875 -57.828125 L 45.1875 -24.039062 C 45.1875 -12.226562 39.984375 -6.113281 30.070312 -6.113281 C 20.238281 -6.113281 14.953125 -12.226562 14.953125 -24.039062 L 14.953125 -57.828125 L 7.765625 -57.828125 L 7.765625 -23.542969 C 7.765625 -8.179688 16.109375 0.992188 30.070312 0.992188 Z M 30.070312 0.992188 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.380618, 141.219383)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.425781 0 L 15.695312 0 L 15.695312 -20.734375 L 28.417969 -20.734375 L 42.542969 0 L 51.300781 0 L 36.761719 -21.476562 C 45.1875 -23.542969 50.390625 -29.90625 50.390625 -39.238281 C 50.390625 -50.722656 42.460938 -57.828125 30.484375 -57.828125 L 8.425781 -57.828125 Z M 15.695312 -27.675781 L 15.695312 -50.886719 L 29.65625 -50.886719 C 38.082031 -50.886719 42.957031 -46.589844 42.957031 -39.238281 C 42.957031 -31.886719 38.082031 -27.675781 29.65625 -27.675781 Z M 15.695312 -27.675781 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(261.89727, 141.219383)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.40625 0 L 9.167969 0 L 14.457031 -13.136719 L 42.625 -13.136719 L 48.078125 0 L 55.761719 0 L 31.96875 -57.828125 L 25.195312 -57.828125 Z M 17.265625 -19.910156 L 28.582031 -47.664062 L 39.898438 -19.910156 Z M 17.265625 -19.910156 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.3223, 141.219383)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.425781 0 L 15.613281 0 L 15.613281 -45.269531 L 47.582031 0 L 54.355469 0 L 54.355469 -57.828125 L 47.253906 -57.828125 L 47.253906 -12.554688 L 15.28125 -57.828125 L 8.425781 -57.828125 Z M 8.425781 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.164028, 139.806242)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.703125 1.238281 C 53.613281 1.238281 66.085938 -13.21875 64.269531 -33.539062 L 30.8125 -33.539062 L 30.8125 -21.808594 L 46.753906 -21.808594 C 45.101562 -16.933594 40.476562 -13.628906 33.867188 -13.628906 C 24.617188 -13.628906 19.246094 -20.15625 19.246094 -28.914062 C 19.246094 -38 25.113281 -44.195312 33.703125 -44.195312 C 38.824219 -44.195312 43.203125 -41.964844 45.433594 -38.328125 L 63.195312 -38.328125 C 59.808594 -50.96875 48.078125 -59.0625 33.457031 -59.0625 C 15.28125 -59.0625 2.808594 -46.671875 2.808594 -28.914062 C 2.808594 -11.070312 15.363281 1.238281 33.703125 1.238281 Z M 33.703125 1.238281 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.236664, 139.806242)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 21.476562 0 L 38.082031 0 L 38.082031 -20.15625 L 59.144531 -57.824219 L 40.230469 -57.824219 L 29.738281 -37.089844 L 25.277344 -45.847656 L 19.164062 -57.824219 L 0.414062 -57.824219 L 21.476562 -20.074219 Z M 21.476562 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.79254, 139.806242)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.113281 0 L 22.632812 0 L 22.632812 -29.324219 L 33.785156 -13.710938 L 44.609375 -13.710938 L 55.675781 -29.242188 L 55.675781 0 L 72.199219 0 L 72.199219 -57.824219 L 58.652344 -57.824219 L 39.15625 -30.316406 L 19.742188 -57.824219 L 6.113281 -57.824219 Z M 6.113281 0 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.1da18e7825eff2869906578a57fb4671.svg";
export { ForwardRef as ReactComponent };